export default "__VITE_ASSET__BR_rop_3__"